import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { UserProvider } from "./context/UserContext"; // Corrected import
import { ThemeProvider } from "./context/ThemeContext"; // Import ThemeProvider
import ProtectedRoute from "./components/ProtectedRoute";
import Navigation from "./components/Navigation";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Feed from "./components/Feed";
import LaunchSchedule from "./components/LaunchSchedule";
import Profile from "./components/Profile"; // New import
import Learn from "./components/Learn"; // New import
import Admin from "./components/Admin"; // New import
import GlobeVisualizer from "./components/GlobeVisualizer"; // New import
import MarsHub from "./components/MarsHub"; // New Mars Hub import
import MarsGlobeVisualizer from "./components/MarsGlobeVisualizer"; // New Mars Globe import
import Forum from "./components/Forum"; // New import
import Livestreams from "./components/Livestreams"; // New import
import ISSVisualizer from "./components/ISSVisualizer"; // ISS Tracker import
import Games from "./components/Games"; // Games import
import F1Dashboard from "./components/F1Dashboard"; // F1 Dashboard import
import SalesProspectingDashboard from "./components/SalesProspectingDashboard"; // Sales Prospecting Dashboard import

function App() {
  return (
    <Router>
      <UserProvider> {/* Corrected provider */}
        <ThemeProvider>
          <Navigation className="sticky top-0 z-10" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Feed />
                </ProtectedRoute>
              }
            />
            <Route
              path="/launch-schedule"
              element={
                <ProtectedRoute>
                  <LaunchSchedule />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mars"
              element={
                <ProtectedRoute>
                  <MarsHub />
                </ProtectedRoute>
              }
            /> {/* Mars Hub route */}
            <Route
              path="/mars-globe"
              element={
                <ProtectedRoute>
                  <MarsGlobeVisualizer />
                </ProtectedRoute>
              }
            /> {/* Mars Globe Visualizer route */}
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            /> {/* Existing route */}
            <Route
              path="/learn"
              element={
                <ProtectedRoute>
                  <Learn />
                </ProtectedRoute>
              }
            /> {/* New route */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            /> {/* Admin route */}
            <Route
              path="/admin/f1-dashboard"
              element={
                <ProtectedRoute>
                  <F1Dashboard />
                </ProtectedRoute>
              }
            /> {/* F1 Dashboard route */}
            <Route
              path="/admin/sales-prospecting"
              element={
                <ProtectedRoute>
                  <SalesProspectingDashboard />
                </ProtectedRoute>
              }
            /> {/* Sales Prospecting Dashboard route */}
            <Route
              path="/globe"
              element={
                <ProtectedRoute>
                  <GlobeVisualizer />
                </ProtectedRoute>
              }
            /> {/* Globe Visualizer route */}
            <Route
              path="/forum"
              element={
                <ProtectedRoute>
                  <Forum />
                </ProtectedRoute>
              }
            /> {/* Forum route */}
            <Route
              path="/livestreams"
              element={
                <ProtectedRoute>
                  <Livestreams />
                </ProtectedRoute>
              }
            /> {/* Livestreams route */}
            <Route
              path="/iss-tracker"
              element={
                <ProtectedRoute>
                  <ISSVisualizer />
                </ProtectedRoute>
              }
            /> {/* ISS Tracker route */}
            <Route
              path="/games"
              element={
                <ProtectedRoute>
                  <Games />
                </ProtectedRoute>
              }
            /> {/* Games route */}
          </Routes>
        </ThemeProvider>
      </UserProvider>
    </Router>
  );
}

export default App;
